import { Drug } from '@/api/domains/drugs.types';
import { Author, Initiator } from '../@types/common.types';
import { FieldMatchingFile } from '@/api/domains/field-matching.types';

// ========== Registry Core ==========
export const REFERENCE_PRICE = 'reference_prices';
export const REIMBURSEMENT_DATA = 'reimbursement_data';

export type RegistryAlias = typeof REFERENCE_PRICE | typeof REIMBURSEMENT_DATA;

export const HIDDEN_REGISTRY_ALIASES: string[] = [];

export const REGISTRY_DISPLAY_NAMES: Record<RegistryAlias, string> = {
  [REFERENCE_PRICE]: 'Реестр референтных цен',
  [REIMBURSEMENT_DATA]: 'Реестр реимбурсационных цен',
};

export type Registry = {
  id: number;
  alias: RegistryAlias;
  name: string;
  created_at: string;
  updated_at: string;
  file_src: string;
  file_name: string;
  binded_drugs: number;
  not_binded_drugs: number;
  skipped_drugs: number;
  statistics: RegistryStatistics;
  author: Author;
  author_id: Author['id'];
  initiator: Initiator;
  initiator_id: Initiator['id'];
};

export type RegistryStatistics = {
  total: number;
  failed: number;
  loaded: number;
  recognized_drugs: number;
  unique_drugs: number;
  valid_columns: RegistryValidColumn[];
};

export type RegistryValidColumn = {
  column: string;
  count: string;
};

// ========== Matching Settings ==========
export type RegistryFieldMatchingSettings = FieldMatchingFile & {
  alias: RegistryAlias;
};

// ========== Row Data ==========
export type RegistryRowDataColumn =
  | 'wholesale_price_with_vat'
  | 'retail_price_with_vat'
  | 'uzpharminfo_id'
  | 'retail_price_with_vat_min'
  | 'retail_price_with_vat_max';

export type RegistryRowDataItem = {
  column: RegistryRowDataColumn;
  value: string;
};

export type RegistryRowData = {
  items: RegistryRowDataItem[];
};

export type RegistryRowItem = {
  id: number;
  alias: RegistryAlias;
  drug_id: number;
  drug_name: string;
  maker_name: string;
  data: RegistryRowData;
  binding_id: number;
  drug: Drug | null;
};

// ========== Logs ==========
export type RegistryLogItem = {
  label: string;
  count: number;
};

export type RegistryLogs = {
  by_state: RegistryLogItem[];
  by_field: RegistryLogItem[];
};

// ========== Error Logs ==========
export type RegistryErrorLogsDataItem = {
  column: RegistryRowDataColumn;
  value: string;
};

export type RegistryErrorLogsData = {
  items: RegistryErrorLogsDataItem[];
};

export type RegistryErrorLogs = {
  row: number;
  nomenclature_name: string;
  maker_name: string;
  data: RegistryErrorLogsData;
};

// ========== Drug Binding ==========
